module.exports = __webpack_public_path__ + "static/img/wx.ebde849.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wx.png
// module id = ZDm/
// module chunks = 128